'use client';

import { OneTimePasswordService } from '@dobrozem/sdk';
import { QueryClient, useQuery } from '@tanstack/react-query';

export const queryClient = new QueryClient();

export const queryKeys = {
  advertisement: 'advertisement',
  calculator: 'calculator',
  districts: 'districts',
  me: 'me',
  otp: 'otp',
  regions: 'regions',
  settlements: 'settlements',
} as const;

export const useOneTimePasswordQuery = (token: string) =>
  useQuery({
    queryFn: () => OneTimePasswordService.findByToken({ path: { token } }),
    queryKey: [queryKeys.otp, token],
  });
